import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { PagesProvider } from "@/context/PagesContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PageView from "@/pages/PageView";
import { AboutPage, ServicesPage, RoutesPage, WhyUsPage, FaqPage, ContactPage, CarsPage } from "@/pages/SectionPages";
import { AssistantWidget } from "@/components/AssistantWidget";
import { useLocation } from "react-router-dom";

function GlobalAssistant() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <AssistantWidget />;
}

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <PagesProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/cars" element={<CarsPage />} />
              <Route path="/routes" element={<RoutesPage />} />
              <Route path="/why-us" element={<WhyUsPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="*" element={<PageView />} />
            </Routes>
            <GlobalAssistant />
          </BrowserRouter>
        </PagesProvider>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
